import { createSlice } from '@reduxjs/toolkit';

import { updateVideoResources } from '@/modules/common/helpers/videoCache';

const initialState = {
  isLoading: true,
  playerPropsPassThrow: {},
  playlist: [],
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'shareVideo',
  initialState,
  reducers: {
    shareVideoFetchStartedAction: (state) => {
      state.isLoading = true;
    },
    shareVideoFetchSuccessAction: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
      });

      state.isLoading = false;
    },
    shareVideoFetchErrorAction: (state) => {
      state.isLoading = false;
    },
    shareVideoClearAction: () => initialState,
    updateSocialMetricAction: (state, action) => {
      state.playlist.forEach((video) => {
        if (video.mediaid === action.payload.mediaid) {
          Object.entries(action.payload.parameters).forEach(([key, value]) => {
            const item = video.performanceData.parameters.find((item$) => item$.type === key);

            if (item) {
              item.value = value;
            }
          });
        }
      });
    },
    updateResourceAction: (state, action) => {
      state.playlist.forEach((video) => {
        updateVideoResources(video, action.payload);
      });
    },
  },
});

export const {
  shareVideoClearAction,
  shareVideoFetchErrorAction,
  shareVideoFetchStartedAction,
  shareVideoFetchSuccessAction,
  updateSocialMetricAction,
  updateResourceAction,
} = slice.actions;
